export default __webpack_public_path__ + "static/media/sakib1.1e98b883.png";